import { render, staticRenderFns } from "./BagPanel.vue?vue&type=template&id=1901a9ea&scoped=true"
import script from "./BagPanel.vue?vue&type=script&lang=js"
export * from "./BagPanel.vue?vue&type=script&lang=js"
import style0 from "./BagPanel.vue?vue&type=style&index=0&id=1901a9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1901a9ea",
  null
  
)

export default component.exports